import React, {useEffect, useState} from 'react';
import {
    CardTitle,
    Button,
    Table
} from 'reactstrap';

import Parametri from '../../parametri';
import Clessidra from '../Clessidra';

function ReportDocce(props) {

    const [tipoReport, setTipoReport] = useState("mese");
    const [dati, setDati] = useState([]);
    const [caricamento, setCaricamento] = useState(false);
    const annoCorrente = new Date().getFullYear();
    const annoScorso = annoCorrente - 1;

    function caricaReport(tipo = tipoReport) {

        setCaricamento(true);
        setDati([]);

        let op = "";
        let modalita = "";
        let anno = 0;

        if (tipo === "mese") {
                op = "reportDocceMese";
        }

        if (tipo === "iscrittoTop100") {
                op = "reportDocceIscritto";
                modalita = "top100";
        }

        if (tipo === "iscrittoAnnoCorrente") {
                op = "reportDocceIscritto";
                modalita = "anno";
                anno = annoCorrente;
        }

        if (tipo === "iscrittoAnnoScorso") {
                op = "reportDocceIscritto";
                modalita = "anno";
                anno = annoScorso;
        }

        fetch(Parametri("serverURL", props.identitaSelezionata), {
                method: 'POST',
                headers: {
                'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                op: op,
                modalita: modalita,
                anno: anno,
                emak: props.emak,
                sessionId: props.sessionId
                })
        })
        .then(risposta => risposta.json())
        .then(
                valoreDiRitorno => {

                setCaricamento(false);

                if (valoreDiRitorno.risultatoOperazione !== 1) {
                        window.alert(
                        valoreDiRitorno.mess !== undefined
                                ? valoreDiRitorno.mess
                                : "Errore durante il caricamento del report"
                        );
                        return;
                }

                if (Array.isArray(valoreDiRitorno.risultatoRitorno)) {
                        setDati(valoreDiRitorno.risultatoRitorno);
                } else {
                        setDati([]);
                }
                },
                () => {
                setCaricamento(false);
                window.alert("Errore di connessione");
                }
        );
        }

    function cambiaTipo(tipo) {
        setTipoReport(tipo);
    }

    useEffect(() => {
        caricaReport(tipoReport);
    }, [tipoReport]);

    const datiPerAnno = {};

    if (tipoReport !== "mese") {
        dati.forEach(r => {
                if (!datiPerAnno[r.ANNO]) {
                datiPerAnno[r.ANNO] = [];
                }
                datiPerAnno[r.ANNO].push(r);
        });
    }

    return (
        <div
            className="schedaContenitore"
            style={{height: props.dimensioniApp.yMain}}
        >

            <div
                className="schedaSpazioCentrale"
                style={{height: props.dimensioniApp.yMain}}
            >

                <CardTitle>
                    Report Docce
                </CardTitle>

                <div style={{marginBottom: "20px"}}>

                        <Button
                                color={tipoReport === "mese" ? "primary" : "secondary"}
                                className="mr-2"
                                onClick={() => cambiaTipo("mese")}
                        >
                                Per mese
                        </Button>

                        <Button
                                color={tipoReport === "iscrittoTop100" ? "primary" : "secondary"}
                                className="mr-2"
                                onClick={() => cambiaTipo("iscrittoTop100")}
                        >
                                Per iscritto Top 100
                        </Button>

                        <Button
                                color={tipoReport === "iscrittoAnnoCorrente" ? "primary" : "secondary"}
                                className="mr-2"
                                onClick={() => cambiaTipo("iscrittoAnnoCorrente")}
                        >
                                Per iscritto {annoCorrente}
                        </Button>

                        <Button
                                color={tipoReport === "iscrittoAnnoScorso" ? "primary" : "secondary"}
                                onClick={() => cambiaTipo("iscrittoAnnoScorso")}
                        >
                                Per iscritto {annoScorso}
                        </Button>

                </div>

                {caricamento ? (

                    <Clessidra loading={true} />

                ) : (

                    <>
                        {dati.length === 0 ? (

                                <div
                                        style={{
                                        textAlign: "center",
                                        marginTop: "30px"
                                        }}
                                >
                                        Nessuna doccia in questo periodo
                                </div>

                                ) : tipoReport === "mese" ? (

                                <div
                                        style={{
                                        background: "#fff",
                                        borderRadius: "14px",
                                        overflow: "hidden",
                                        boxShadow: "0 2px 10px rgba(0,0,0,0.08)"
                                        }}
                                >
                                        <Table
                                        responsive
                                        hover
                                        borderless
                                        className="mb-0"
                                        >
                                        <thead
                                                style={{
                                                background: "#f3f5f7"
                                                }}
                                        >
                                                <tr>
                                                <th
                                                        style={{
                                                        padding: "14px 18px",
                                                        fontWeight: "600"
                                                        }}
                                                >
                                                        Mese
                                                </th>

                                                <th
                                                        style={{
                                                        padding: "14px 18px",
                                                        textAlign: "right",
                                                        fontWeight: "600"
                                                        }}
                                                >
                                                        Docce
                                                </th>
                                                </tr>
                                        </thead>

                                        <tbody>
                                                {dati.map((r, index) => (
                                                <tr key={index}>
                                                        <td
                                                        style={{
                                                                padding: "4px 18px",
                                                                verticalAlign: "middle",
                                                                borderBottom: "1px solid #E9E9E9"
                                                        }}
                                                        >
                                                        {r.MESE}
                                                        </td>

                                                        <td
                                                        style={{
                                                                padding: "4px 18px",
                                                                textAlign: "right",
                                                                verticalAlign: "middle",
                                                                fontWeight: "600",
                                                                borderBottom: "1px solid #E9E9E9"
                                                        }}
                                                        >
                                                        {r.NUMERO_DOCCE}
                                                        </td>
                                                </tr>
                                                ))}
                                        </tbody>
                                        </Table>
                                </div>

                                ) : (

                                <>
                                        {Object.keys(datiPerAnno)
                                        .sort((a, b) => parseInt(b) - parseInt(a))
                                        .map(anno => (

                                                <div
                                                key={anno}
                                                style={{
                                                        marginBottom: "28px"
                                                }}
                                                >

                                                <div
                                                        style={{
                                                        fontSize: "20px",
                                                        fontWeight: "600",
                                                        marginBottom: "10px"
                                                        }}
                                                >
                                                        {anno}
                                                </div>

                                                <div
                                                        style={{
                                                        background: "#fff",
                                                        borderRadius: "14px",
                                                        overflow: "hidden",
                                                        boxShadow: "0 2px 10px rgba(0,0,0,0.08)"
                                                        }}
                                                >

                                                        <Table
                                                        responsive
                                                        hover
                                                        borderless
                                                        className="mb-0"
                                                        >

                                                        <thead
                                                                style={{
                                                                background: "#f3f5f7"
                                                                }}
                                                        >
                                                                <tr>

                                                                <th
                                                                        style={{
                                                                        padding: "14px 18px",
                                                                        fontWeight: "600"
                                                                        }}
                                                                >
                                                                        Iscritto
                                                                </th>

                                                                <th
                                                                        style={{
                                                                        padding: "14px 18px",
                                                                        textAlign: "right",
                                                                        fontWeight: "600",
                                                                        width: "130px"
                                                                        }}
                                                                >
                                                                        Docce
                                                                </th>

                                                                </tr>
                                                        </thead>

                                                        <tbody>

                                                                {datiPerAnno[anno].map((r, index) => (

                                                                <tr key={r.IDPERSONA || index}>

                                                                        <td
                                                                        style={{
                                                                                padding: "4px 18px",
                                                                                verticalAlign: "middle",
                                                                                borderBottom: "1px solid #E9E9E9"
                                                                        }}
                                                                        >
                                                                        <b>{r.COGNOME}</b>
                                                                        {r.NOME ? " " + r.NOME : ""}
                                                                        </td>

                                                                        <td
                                                                        style={{
                                                                                padding: "4px 18px",
                                                                                textAlign: "right",
                                                                                verticalAlign: "middle",
                                                                                fontSize: "16px",
                                                                                fontWeight: "600",
                                                                                borderBottom: "1px solid #E9E9E9"
                                                                        }}
                                                                        >
                                                                        {r.NUMERO_DOCCE}
                                                                        </td>

                                                                </tr>

                                                                ))}

                                                        </tbody>

                                                        </Table>

                                                </div>

                                                </div>

                                        ))}
                                </>

                                )}
                    </>

                )}

            </div>

        </div>
    );
}

export default ReportDocce;